module.exports = __webpack_public_path__ + "media/src/img/nd_qr_tinkoff-af6de55ff0d11c4cce3569bde470483c.png";